import { Chip } from "@mui/material";
import useColors from "../api/hooks/useColors";
import CustomTooltip from "./CustomTooltip";

const IconChip = ({
  icon,
  bgcolor = null,
  shadowColor = null,
  boxShadow = null,
  tooltip = null,
  sx = {},
  ...props
}) => {
  const colors = useColors();

  const chipBgColor = bgcolor || colors.chip_primary_enabled_bg;
  const chipShadowColor = shadowColor || colors.primary_48percent;
  const chipBoxShadow = boxShadow || `0px 0px 1px 0px ${chipShadowColor}`;

  const ChipComponent = (
    <Chip
      sx={{
        background: chipBgColor,
        borderRadius: "8px",
        padding: "3px",
        boxShadow: chipBoxShadow,
        "& .MuiChip-label": {
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        ...sx,
      }}
      label={icon}
      {...props}
    />
  );

  return tooltip ? (
    <CustomTooltip title={tooltip}>{ChipComponent}</CustomTooltip>
  ) : (
    ChipComponent
  );
};

export default IconChip;
